import axios from "axios";
import Swal from "sweetalert2";
import "../components/swalStyle/customStyle.css";

const dataToken = localStorage.getItem("token");
const URL = process.env;
const instace = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

export const login = async (data) => {
  try {
    const response = await instace.post(`/api/auth/login`, data);
    if (response.status === 200) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    Swal.fire({
      icon: "error",
      title: "Incorrect email or password.",
      confirmButtonText: "OK",
    }).then((result) => {});
  }
};
